import { createAction } from '@reduxjs/toolkit';
import { MetaState } from './types';

export const setStartedFrom = createAction(
    '@@users/SET_STARTED_FROM',
    (payload: string | null | undefined) => ({
        payload: payload as MetaState['startedFrom'],
    }),
);
